module.exports = require('./lib/uslug');


//////////////////
// WEBPACK FOOTER
// ./~/uslug/index.js
// module id = 929
// module chunks = 0